import React from 'react';

const About = () => (
  <div className="about-us">
    <h1 className="about">About Us</h1>
    <p>
      Hotel Getter is the best place to get your stomach taken care of. We
      are situated at ***** Trans Ekulu Enugu Nigeria. Contact us today for your
      wedding, Child dedications, burial ceremonies etc
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel labore
      distinctio, perspiciatis, pariatur veritatis quam ut blanditiis in,
      deleniti sed et deserunt sint a dolores animi suscipit eveniet dolorum
      incidunt. Earum dignissimos dolor sunt odio quas illum perspiciatis
      inventore commodi magni. Beatae deserunt reprehenderit aut quo tenetur
      magni animi distinctio?
    </p>
  </div>
);

export default About;
